/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.58
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import NumberBoundary from './NumberBoundary';

/**
 * The AqaTableQualityDefinition model module.
 * @module model/AqaTableQualityDefinition
 * @version v0
 */
export default class AqaTableQualityDefinition {
  /**
   * Constructs a new <code>AqaTableQualityDefinition</code>.
   * @alias module:model/AqaTableQualityDefinition
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>AqaTableQualityDefinition</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/AqaTableQualityDefinition} obj Optional instance to populate.
   * @return {module:model/AqaTableQualityDefinition} The populated <code>AqaTableQualityDefinition</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new AqaTableQualityDefinition();
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'String');
      if (data.hasOwnProperty('lastModifiedTimestamp'))
        obj.lastModifiedTimestamp = ApiClient.convertToType(data['lastModifiedTimestamp'], 'Number');
      if (data.hasOwnProperty('useColumnNumbers'))
        obj.useColumnNumbers = ApiClient.convertToType(data['useColumnNumbers'], 'Boolean');
      if (data.hasOwnProperty('columnNumberBoundary1'))
        obj.columnNumberBoundary1 = NumberBoundary.constructFromObject(data['columnNumberBoundary1']);
      if (data.hasOwnProperty('columnNumberBoundary2'))
        obj.columnNumberBoundary2 = NumberBoundary.constructFromObject(data['columnNumberBoundary2']);
      if (data.hasOwnProperty('useRowNumbers'))
        obj.useRowNumbers = ApiClient.convertToType(data['useRowNumbers'], 'Boolean');
      if (data.hasOwnProperty('rowNumberBoundary1'))
        obj.rowNumberBoundary1 = NumberBoundary.constructFromObject(data['rowNumberBoundary1']);
      if (data.hasOwnProperty('rowNumberBoundary2'))
        obj.rowNumberBoundary2 = NumberBoundary.constructFromObject(data['rowNumberBoundary2']);
    }
    return obj;
  }
}

/**
 * @member {String} id
 */
AqaTableQualityDefinition.prototype.id = undefined;

/**
 * @member {Number} lastModifiedTimestamp
 */
AqaTableQualityDefinition.prototype.lastModifiedTimestamp = undefined;

/**
 * @member {Boolean} useColumnNumbers
 */
AqaTableQualityDefinition.prototype.useColumnNumbers = undefined;

/**
 * @member {module:model/NumberBoundary} columnNumberBoundary1
 */
AqaTableQualityDefinition.prototype.columnNumberBoundary1 = undefined;

/**
 * @member {module:model/NumberBoundary} columnNumberBoundary2
 */
AqaTableQualityDefinition.prototype.columnNumberBoundary2 = undefined;

/**
 * @member {Boolean} useRowNumbers
 */
AqaTableQualityDefinition.prototype.useRowNumbers = undefined;

/**
 * @member {module:model/NumberBoundary} rowNumberBoundary1
 */
AqaTableQualityDefinition.prototype.rowNumberBoundary1 = undefined;

/**
 * @member {module:model/NumberBoundary} rowNumberBoundary2
 */
AqaTableQualityDefinition.prototype.rowNumberBoundary2 = undefined;

